import { combineReducers } from "redux";
import theme from "./slices/themeSlice";
import auth from "./slices/authSlice";
import settingSystem from "./slices/settingSystemSlice";
import location from "./slices/locationSlice";
import orderApi from "./slices/OrderCustomerSlice";
import report from "./slices/reportSlice";
import notification from "./slices/NotificationSlice";
import voucher from "./slices/VoucherSlice";
import customer from "./slices/CustomerSlice";
import employee from "./slices/EmployeeSlice";
import vehicle from "./slices/VehicleSlice";
import priceSetting from "./slices/PriceSettingSlice";
import driver from "./slices/DriverSlice";
import shiftDriver from "./slices/ShiftDriverSlice";
import warning from "./slices/WarningSlice";
import monitor from "./slices/monitorSlide";
import place from "./slices/PlaceSlice";
import order from "./slices/OrderSlice";
import orderPayment from "./slices/OrderPaymentSlice";
import otherSetting from "./slices/OtherSettingSlice";
import driverFeedback from "./slices/DriverFeedbackSlice";
import workingArea from "./slices/workingAreaSlice";
import orderReason from "./slices/OrderReasonSlice";
import language from "./slices/LanguageSlice";
import settingHideOrder from "./slices/SettingHideOrderSlide";
import settingMaps from "./slices/SettingMapsSlice";
import settingTripDelay from "./slices/SettingTripDelaySlice";
import settingDriverFindingRule from "./slices/SettingDriverFindingRuleSlice";
import settingAuthsSlice from "./slices/SettingAuthsSlice";
import settingVehicleTypeSlice from "./slices/SettingVehicleTypeSlice";
import orderCancelSlice from "./slices/OrderCancelSlice";
import vehicleExpense from "./slices/VehicleExpenseSlice";
import settingSurchargeCategory from "./slices/SettingSurchargeCategorySlice";
import pricingSlice from "./slices/PricingSlice";
import orderTrip from "./slices/OrderTripSlice";
import bankAccount from "./slices/BankAccountSlice";
import airline from "./slices/AirlineSlice";
import role from "./slices/RoleSlice";
import permission from "./slices/PermissionSlice";
import surchargeSlip from "store/slices/surchargeSlipSlice";
import documentCodeSlice from "store/slices/DocumentCodeSlice";
import flightRouteSlice from "./slices/FlightRouteSlice";

const rootReducer = (asyncReducers) => (state, action) => {
  const combinedReducer = combineReducers({
    theme,
    auth,
    settingSystem,
    location,
    customer,
    employee,
    orderApi,
    report,
    notification,
    driver,
    vehicle,
    priceSetting,
    voucher,
    shiftDriver,
    warning,
    monitor,
    place,
    order,
    orderPayment,
    driverFeedback,
    otherSetting,
    workingArea,
    orderReason,
    language,
    settingHideOrder,
    settingMaps,
    settingTripDelay,
    settingDriverFindingRule,
    settingAuthsSlice,
    settingVehicleTypeSlice,
    orderCancelSlice,
    vehicleExpense,
    settingSurchargeCategory,
    pricingSlice,
    orderTrip,
    bankAccount,
    airline,
    role,
    permission,
    surchargeSlip,
    documentCodeSlice,
    flightRouteSlice,

    ...asyncReducers,
  });
  return combinedReducer(state, action);
};

export default rootReducer;
